import { Highlight, Language, RenderProps } from 'prism-react-renderer';
import codeExampleTheme from './code-example-theme';

const languageLabels = {
  python: 'Python',
  javascript: 'JavaScript',
} as const;

type SupportedLanguage = keyof typeof languageLabels;

type CodeExampleProps = {
  code: string;
  language: SupportedLanguage;
  title?: string;
  className?: string;
};

export default function CodeExample({ code, language, title, className }: CodeExampleProps) {
  const trimmedCode = code.replace(/\s+$/, '');
  const highlightLanguage = language as Language;
  const containerClassName = ['code-example', className].filter(Boolean).join(' ');

  return (
    <div className={containerClassName}>
      <div className="code-example__header">
        <span className="code-example__label">{title ?? 'Code Example'}</span>
        <span className="code-example__language">{languageLabels[language]}</span>
      </div>
      <Highlight code={trimmedCode} language={highlightLanguage} theme={codeExampleTheme}>
        {({ className: highlightClassName, style, tokens, getLineProps, getTokenProps }: RenderProps) => (
          <pre className={highlightClassName} style={style}>
            {tokens.map((line, lineIndex) => (
              <div key={lineIndex} {...getLineProps({ line })}>
                {line.map((token, tokenIndex) => (
                  <span key={tokenIndex} {...getTokenProps({ token })} />
                ))}
              </div>
            ))}
          </pre>
        )}
      </Highlight>
    </div>
  );
}
